import { objectEntries } from "~/helpers/general";
import { getProducts } from "~/helpers/http";
import type { CountryKey } from "~/types";

export default async function useProducts(country: CountryKey) {
  const { productReplacement, productNote } = useBranch(); // Up here to avoid Nuxt Instance Unavailable - https://www.youtube.com/watch?v=ofuKRZLtOdY
  const { data } = await useAsyncData(country, () => getProducts(country), {
    transform: products => {
      if (productNote) {
        for (const product of products) {
          if (productNote[product.name]) {
            product.note = productNote[product.name];
          }
        }
      }

      if (productReplacement) {
        for (const entry of objectEntries(productReplacement)) {
          const [original, replacement] = entry!;
          const originalIndex = products.findIndex(p => p.name == original);
          if (originalIndex == -1) continue;
          products.splice(originalIndex, 1);
          products.find(p => p.name == replacement)!.replacement!.active = true;
        }
      }

      return products.filter(p => !p.replacement || p.replacement.active);
    }
  });

  if (!data.value) throw new Error('Failed getting products.');
  return data.value;
}